import React from 'react';
import SelectBillFP from '../FullPagesComponents/Services/SelectBillFP';
import SimulatorsViewerArrangement from '../FullPagesComponents/SimulatorsViewerArrangement';
import { Bills_list_main_view, Bills_list_scrolled_bottom } from '../../../utils/DictionaryManagementUtils';

//= ========================================================================
const SelectBillDF = ({
  globJSON,
  selectedScreen,
  language,
  simPlatform,
  slideshowRefs = null,
}) => (
  <SimulatorsViewerArrangement>
    <SelectBillFP
      globJSON={globJSON}
      selectedScreen={selectedScreen}
      language={language}
      simPlatform={simPlatform}
      slideshowRefs={slideshowRefs}
      TopTitle={Bills_list_main_view}
    />
    <SelectBillFP
      globJSON={globJSON}
      selectedScreen={selectedScreen}
      language={language}
      simPlatform={simPlatform}
      slideshowRefs={slideshowRefs}
      withEnterBtn
      TopTitle={Bills_list_scrolled_bottom}
    />
  </SimulatorsViewerArrangement>
);

export default SelectBillDF;
